import React from "react";

/**
 * Overall data/KPI cards — certificate (expense) module design.
 * Each card: white bg, colored top border, icon chip + label/value/sub.
 *
 * stats: [{ label, value, color, icon, sub }]
 */
const CommStatCards = ({ stats, onCardClick, activeKey }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
      gap: 16,
      marginBottom: 24,
    }}
  >
    {stats.map(({ label, value, color, icon, sub, key }) => {
      const id = key || label;
      const clickable = typeof onCardClick === "function";
      const active = clickable && activeKey === id;
      return (
      <div
        key={label}
        onClick={clickable ? () => onCardClick(id) : undefined}
        style={{
          background: active ? `${color}10` : "#fff",
          border: active ? `1px solid ${color}` : "1px solid #e5e7eb",
          borderTop: `4px solid ${color}`,
          borderRadius: 14,
          padding: "16px 18px",
          boxShadow: active ? `0 4px 12px ${color}33` : "0 2px 8px rgba(0,0,0,0.04)",
          display: "flex",
          alignItems: "center",
          gap: 14,
          cursor: clickable ? "pointer" : "default",
          transition: "box-shadow 0.15s ease, border-color 0.15s ease",
        }}
      >
        <div
          style={{
            background: `${color}15`,
            color,
            borderRadius: 10,
            width: 46,
            height: 46,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <i className={icon} style={{ fontSize: 20 }} />
        </div>
        <div>
          <div
            style={{
              fontSize: 10,
              color: "#6b7280",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {label}
          </div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#1f2937", lineHeight: 1.2 }}>
            {value}
          </div>
          {sub ? <div style={{ fontSize: 11, color: "#9ca3af" }}>{sub}</div> : null}
        </div>
      </div>
      );
    })}
  </div>
);

export default CommStatCards;
